// Campus photo for /colleges/university-of-nebraska-lincoln: CC BY-SA 4.0, by Hanyou23, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ALloyd_G._Tanner_Plaza_%26_Morrill_Hall%2C_University_of_Nebraska-Lincoln%2C_Lincoln%2C_Nebraska%2C_USA.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-nebraska-lincoln/; credited under the photo.
const photo = {
    "slug": "university-of-nebraska-lincoln",
    "alt": "Morrill Hall and the bronze mammoth on Lloyd G. Tanner Plaza at the University of Nebraska-Lincoln in Lincoln, Nebraska",
    "src": "/colleges/university-of-nebraska-lincoln/campus-1600.webp",
    "srcSmall": "/colleges/university-of-nebraska-lincoln/campus-800.webp",
    "srcMid": "/colleges/university-of-nebraska-lincoln/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-nebraska-lincoln/og.jpg",
    "title": "Lloyd G. Tanner Plaza & Morrill Hall, University of Nebraska-Lincoln, Lincoln, Nebraska, USA",
    "author": "Hanyou23",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ALloyd_G._Tanner_Plaza_%26_Morrill_Hall%2C_University_of_Nebraska-Lincoln%2C_Lincoln%2C_Nebraska%2C_USA.jpg",
    "read": "2026-10-01"
};

export default photo;
